import styled from "styled-components";
import { setFlex, setPosition } from "../../variables/Position";
import { BREAKPOINTS } from "../../variables/Breakpoints";

export const GalleryScaleWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  min-height: auto;
`;

export const Container = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({
    justify: "flex-end",
    align: "center",
    direction: "column",
  })};
  min-height: 200vh;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    min-height: auto;
  }
`;

export const HeadlineVideo = styled.div`
  ${setFlex({})};
`;

export const VideoLanding = styled.div`
  ${setFlex({})};
  flex: 1;
  margin-bottom: 1rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    display: none;
  }
`;
